import { Navigate } from 'react-router-dom';
import { useMerchantAuth } from '../../../contexts/AuthContext';
import RequirePermission from '../../../shared/components/RequirePermission';
import DashboardAnalytics from '../../dashboard/pages/DashboardAnalyticsPage';

/**
 * Dashboard index: platform admins go straight to the admin console; merchants see analytics.
 */
export default function DashboardHomeRedirect() {
    const { loyalpassAdmin } = useMerchantAuth();
    if (loyalpassAdmin) {
        return <Navigate to="/dashboard/loyalpass-admin/merchants" replace />;
    }
    return (
        <RequirePermission permission="view_dashboard">
            <DashboardAnalytics />
        </RequirePermission>
    );
}
